__turbopack_context__.v({
  "card": "StepForm-module-scss-module__llX2ha__card",
  "card_step2": "StepForm-module-scss-module__llX2ha__card_step2",
  "form": "StepForm-module-scss-module__llX2ha__form",
  "form_tip": "StepForm-module-scss-module__llX2ha__form_tip",
  "intro": "StepForm-module-scss-module__llX2ha__intro",
  "next_button": "StepForm-module-scss-module__llX2ha__next_button",
  "step2_action": "StepForm-module-scss-module__llX2ha__step2_action",
  "step2_form": "StepForm-module-scss-module__llX2ha__step2_form",
});
